import React, { FC } from 'react';
import { ICarouselItem } from '../../model/types';
import './CarouselItem.less';

interface ICarouselItemProps {
  item: ICarouselItem;
}

const CarouselItem: FC<ICarouselItemProps> = (props) => {
  const { item } = props;
  return (
    <li className="carousel-item">
      <a href={item.link}>
        <img className="carousel-img" src={item.image} alt={item.title} />
        <p>{item.title}</p>
      </a>
    </li>
  );
};

export default CarouselItem;
